module.exports = __webpack_public_path__ + "img/collar_edges_length.b385d62d.png";